import * as React from 'react';

import GenDirectionalButtons from './DirectionalButtons'

type SortOrder =  "DESC" | "ASC"

interface GenSortButtonsProps {
  setListSort: (value: string, direction: SortOrder) => void;
  resetListPages: () => void;
  readListPage: () => void;
  sortOptions: Array<{
    disabled?: boolean;
    value: string;
    title: string;
  }>;
  sort_by?: string;
  sort_order?: SortOrder;
}

export default function GenSortButtons(
  {
    setListSort,
    resetListPages,
    readListPage,
    sortOptions,
    sort_by,
    sort_order,
  }: GenSortButtonsProps,
) {
  const updateSort = (newSortValue: string, newSortDirection: "descending" | "ascending") => {
    (newSortDirection === "descending") ? "DESC" : "ASC"

    setListSort(newSortValue, newSortDirection === "descending" ? "DESC" : "ASC")
    resetListPages()
    readListPage()
  }

  return (
    <GenDirectionalButtons
      buttons={sortOptions}
      selectedValue={sort_by}
      selectedDirection={sort_order === "DESC" ? "descending" : "ascending"}
      onUpdate={updateSort}
    />
  );
}
